module.exports = __webpack_public_path__ + "static/media/computer-download.0029026b.png";